export const initVenueMenusExperiment = () => {
  const $experimentWrapper = $('#venue-menus-experiment');

  if (!$experimentWrapper.length) {
    return;
  }

  $experimentWrapper.onIntersection(() => {
    App.track.event('venue_page_interaction', {
      section: 'facilities_and_catering_options',
      element: 'see_menu',
      interaction: 'visible',
    });
  });

  $('.c-menu-cards__item').on('click', (menu) => {
    App.track.event('venue_page_interaction', {
      section: 'facilities_and_catering_options',
      element: 'see_menu',
      element_value: menu.currentTarget.dataset.menuId,
      interaction: 'click',
    });
  });
};
